import { useEffect, useState } from "react";
import { motion } from "framer-motion";

function HeroSection({ id }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 640);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <section id={id} className="bg-background py-16 px-4 font-anton">
      <div className="mx-auto max-w-screen-xl grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Texto */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className={isMobile ? "text-center" : "text-left"}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 font-anton">
            Impulsa tu negocio con tecnología a medida
          </h2>
          <p className="text-gray-300 text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
            Creamos páginas web modernas, sistemas personalizados y soluciones
            ecommerce que se adaptan 100% a tus necesidades. Optimiza tu
            operación y vende más con el respaldo de expertos.
          </p>
          <div className={isMobile ? "justify-center flex" : "mt-6"}>
            <a href="#contacto">
              <button className="bg-white text-background font-semibold px-6 py-3 rounded-lg shadow-md transition-all hover:bg-accent hover:text-white hover:scale-105">
                ¡Solicita una demo!
              </button>
            </a>
          </div>
        </motion.div>

        {/* Imagen */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <img
            src="/celular-chilsmart.webp"
            alt="App ChilSmart"
            className="w-full h-auto object-cover rounded-2xl shadow-lg border border-gray-700"
          />
        </motion.div>
      </div>
    </section>
  );
}

export default HeroSection;
